<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      :class="{
        opened: opened.indexOf('appendUser') >= 0,
        'last-active': opened.indexOf('appendUser') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="runEdit()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozit") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2 v-if="users.length > 0">
          {{ $t("priradit") }}
          <span v-if="users.length > 1 && users.length < 5">{{ users.length }} {{ $t("uzivatele") }}</span>
          <span v-else-if="users.length > 5">{{ users.length }} {{ $t("uzivatelu") }}</span>
          <span v-else>{{ $t("uzivatele1") }} {{ users[0].email }}</span>
          {{ $t("kProjektu") }}
        </h2>
      </div>
      <div v-if="projects" class="side-box__content">
        <div class="my-4">
          <FormSelectMultiple
            :items="projects"
            :label="$t('vyberteProjekt')"
            :placeholder="$t('SELECT_PROJECT_FROM_LIST')"
            :value="selectedProjects"
            class="mb-3"
            item-text="projectName"
            item-value="projectId"
            side-box
            @change="selectedProjects = $event"
          />
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleConfirmation"
      @no="closeBox('appendUser')"
      @yes="runSave()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal
        :centered="true"
        :errors="errorsToTranslate"
        :opened="openedError"
        @close="
          () => {
            openedError = false
            $emit('closeBox', 'appendUser')
          }
        "
      />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import FormSelectMultiple from "@/components/forms/FormSelectMultiple.vue"
import { useCustomerStore } from "@/store/modules/customer"

export default {
  components: {
    FormSelectMultiple,
    SaveConfirmationModal,
    ErrorModal
  },
  props: {
    users: Array,
    opened: Array
  },
  setup() {
    const customerStore = useCustomerStore()

    return { customerStore }
  },
  data() {
    return {
      projects: [],
      selectedProjects: [],
      projectsOpened: false,
      selectProjectVisible: false,
      openedError: false,
      errorsToTranslate: [],
      openedConfirmation: false
    }
  },
  computed: {
    storedCustomer() {
      return this.customerStore.selectedCustomer
    }
  },
  watch: {
    storedCustomer() {
      this.loadProjects()
    }
  },
  mounted() {
    if (this.storedCustomer) {
      this.loadProjects()
    }
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box === "appendUser") {
        this.$emit("closeBox", box)
      } else {
        this.errors.endpoint = ""
        this.$emit("closeBox", box)
      }
    },
    loadProjects() {
      this.projects = []
      axios
        .get(process.env.VUE_APP_API + "/customers/" + this.storedCustomer.customerId + "/projects?limit=1000")
        .then((result) => {
          this.projects = result.data.data
        })
        .catch(() => {})
    },
    toggleConfirmation() {
      this.openedConfirmation = this.openedConfirmation ? false : true
    },
    addRemoveProject(project) {
      if (this.selectedProjects.indexOf(project) == -1) {
        this.selectedProjects.push(project)
      } else {
        this.selectedProjects.splice(this.selectedProjects.indexOf(project), 1)
      }
      //
    },
    runEdit() {
      this.errorsToTranslate = []
      let promises = []
      this.users.forEach((item) => {
        this.selectedProjects.forEach((project) => {
          promises.push(
            axios
              .put(
                process.env.VUE_APP_API +
                  "/users/" +
                  item.userId +
                  "/customers/" +
                  this.storedCustomer.customerId +
                  "/projects/" +
                  project.projectId +
                  "/privileges",
                { privilege: "ProjectAdmin" }
              )
              .then(
                /*result*/ () => {
                  this.$emit("closeBox", "appendUser")
                }
              )
              .catch((error) => {
                this.errorsToTranslate.push(error.data)
              })
          )
        })
      })
      Promise.all(promises).then(() => {
        if (this.errorsToTranslate.length > 0) {
          this.openedError = true
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
